import React from 'react';
import Card from '../components/card';
import { DollarTextField } from '../components/MaskedTextField';
import style from '../styles/form';
import { LoanCard } from './card-lenses';

const validateCashOut = (num) => (num >= 0 ? '' : 'Cash out amount must be valid');

const titleText = `Approximately how much cash would you like to receive at closing?`;

const CashOut = ({ model, onChange, ...cardProps }) => (
  <Card title={titleText} {...cardProps}>
    <DollarTextField
      value={model.get('cashOutValue')}
      onChange={onChange.bind(null, 'cashOutValue')}
      style={style.threeQuarters}
      floatingLabelText="Cash Out Amount ($)"
      validate={validateCashOut}
    />
  </Card>
);

CashOut.id = 'CashOut';

CashOut.completed = ({ model }) =>
  !DollarTextField.validate(model.get('cashOutValue'), validateCashOut);

export default LoanCard(CashOut);



// WEBPACK FOOTER //
// ./src/cards/cash-out.js